module.exports = __webpack_public_path__ + "static/media/empathy_map_new.061d48d3.png";